import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"

import { to_currency } from "helpers/number"

import {
  ProductBox,
  ProductImage,
  ProductTitle,
  ProductPrice,
} from "./components"
import WishlistIcon from "./wishlist-icon"

const LineItem = ({ item }) => (
  <Box position="relative">
    <Box as={Link} display="block" to={item.modify_url}>
      <ProductBox>
        <ProductImage alt={item.title} ratio="1 / 1" src={item.image_url} />
        <ProductTitle title={item.title}>{item.title}</ProductTitle>
        {item.on_sale ? (
          <ProductPrice>
            from (
            <Typography as="strike" fontWeight="500">
              {to_currency(item.retail_price)}
            </Typography>
            ){" "}
            <Typography as="span" color="sale" fontWeight="500">
              {to_currency(item.price)}
            </Typography>
          </ProductPrice>
        ) : (
          <ProductPrice fontWeight="500">
            from {to_currency(item.price)}
          </ProductPrice>
        )}
      </ProductBox>
    </Box>
    <WishlistIcon item={item} />
  </Box>
)

LineItem.propTypes = {
  item: PropTypes.object,
}

export default LineItem
